import { activityDashboardApi } from '../api/activityDashboardApi';
import { ActivityDashboardResponse } from '../types/activityDashboard';
import { useBaseQuery } from './useBaseQuery';

export const activityDashboardKeys = {
    all: ['activityDashboard'] as const,
    activity: (startDate: string, endDate: string) =>
        [...activityDashboardKeys.all, startDate, endDate] as const,
};

export const useActivityDashboard = (startDate: string, endDate: string) =>
    useBaseQuery<ActivityDashboardResponse>(
        activityDashboardKeys.activity(startDate, endDate),
        () => activityDashboardApi.getActivity(startDate, endDate),
        {
            enabled: !!startDate && !!endDate,
            staleTime: 60 * 1000,
            refetchInterval: 60 * 1000,
        },
    );
